<template>
  <div class="dd-container container">
    <p class="title">{{$t('about')}}</p>

    <Banner :list="detail.imgs" />

    <div class="intro-wrap">
      <div class="intro-wrap-left">
        <p class="name">{{detail.name}}</p>
        <p class="information">{{detail.information}}</p>
      </div>
      <div
        class="intro-wrap-right"
        v-html="detail.content"
      >
      </div>
    </div>

    <div class="address">
      <p>{{$t('tokyo')}}</p>
      <img src="~assets/img/common/about-2.jpg">
    </div>

    <div class="address">
      <p>{{$t('beijing')}}</p>
      <img src="~assets/img/common/about-1.jpg">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Banner from '@pc/about/banner'

export default {
  components: {
    Banner
  },

  computed: {
    ...mapState('about', ['detail'])
  },

  async fetch ({ store, app }) {
    await store.dispatch('about/getDetail', {
      app
    })
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: 77px 0 32px;

  .title {
    margin-bottom: 38px;
    color: #000000;
    text-align: center;
    font-size: 24px;
  }

  .intro-wrap {
    display: flex;
    justify-content: space-between;
    margin: 34px 0 32px;
  }

  .intro-wrap-left {
    width: 350px;
  }

  .name {
    margin-bottom: 20px;
    color: #000000;
    font-weight: bold;
    font-size: 30px;
    line-height: 34px;

    @include clamps-text-overflow(1);
  }

  .information {
    color: #000000;
    font-weight: bold;
    font-size: 24px;
    line-height: 32px;

    @include clamps-text-overflow(1);
  }

  .intro-wrap-right {
    width: 798px;
    color: #000000;
    font-weight: 200;
    font-size: 14px;
    line-height: 28px;
  }

  .address {
    display: flex;
    justify-content: space-between;
    padding: 34px 0;
    border-top: 1px solid #e5e5e5;

    img {
      width: 1118px;
      height: 275px;

      object-fit: cover;
    }

    p {
      color: #000000;
      font-weight: bold;
      font-size: 24px;
    }
  }
}
</style>
